module.exports = __webpack_public_path__ + "static/media/eggs_stamp.50f7d652.svg";